export default __webpack_public_path__ + "static/media/NEAS0480.34I-36624_-21530_0.b61421c7.jpg";